import { defineStore } from "pinia";

import { datapointService } from "@/services";

import { useBrandStore } from "@/stores/brand-store";
import { useCaseStore } from "@/stores/case-store";

import type { DataPoint } from "@/models/DataPoint";

interface State {
  datapoints: Partial<Record<string, Record<string, DataPoint>>>;
}

export const useDatapointStore = defineStore("datapoint", {
  scope: "case",
  state: (): State => ({
    datapoints: {},
  }),
  actions: {
    async load(payload: { fileReference: string; reference: string }) {
      const { selectedCaseName } = useCaseStore();
      const { selectedClient, selectedBrand } = useBrandStore();

      if (selectedClient == null || selectedBrand == null || selectedCaseName == null) return;

      try {
        const datapoint = await datapointService.getDataPoint(
          selectedClient,
          selectedBrand,
          selectedCaseName,
          payload.fileReference,
          payload.reference,
        );

        this.storeDataPoint(payload.fileReference, datapoint);
      } catch (e) {
        console.error(e);
      }
    },

    // Mutations
    storeDataPoint(fileReference: string, dataPoint: DataPoint): void {
      this.datapoints[fileReference] = { ...this.datapoints[fileReference], [dataPoint.reference]: dataPoint };
    },
  },
});
